import React, { useState } from 'react'
import axios from 'axios'
import styled from 'styled-components'
import closeImg from '../../assets/close.png'
import AddressAutocomplete from './AddressAutocomplete'
import colors from '../../styles/colors'
const apiUrl =
    process.env.NODE_ENV === 'production'
        ? '/api'
        : process.env.REACT_APP_API_URL
const StyledSignupFormContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`
const StyledSignupFormBox = styled.div`
    position: relative;
    p {
        position: absolute;
        right: 20px;
        top: 5px;
        font-size: 30px;
        transition: all 0.3s ease-in-out;
        &:hover {
            cursor: pointer;
            filter: brightness(0.8);
        }
    }
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${colors.fifth};
    color: #c8c8c8;
    box-shadow: 0 0 50px black;
    border-radius: 20px;
    padding: 20px 30px;
`
const StyledSigninForm = styled.form`
    div {
        display: flex;
        margin-top: 5px;
        label {
            width: 200px;
        }
        input {
            border-radius: 5px;
            background-color: #c6c6c6;
        }
    }
`
const StyledButton = styled.div`
    width: 150px; /* Largeur du cercle */
    height: 50px; /* Hauteur du cercle, identique à la largeur pour un cercle */
    margin: auto;
    background-color: ${colors.fifth}; /* Couleur de fond */
    filter: brightness(0.6);
    color: white;
    border-radius: 50px; /* Rend le div circulaire */
    display: flex; /* Utilise Flexbox pour l'alignement */
    align-items: center; /* Centre verticalement le contenu */
    justify-content: center; /* Centre horizontalement le contenu */
    text-align: center; /* Centre le texte en cas de texte long */
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &:hover {
        filter: brightness(0.4);
    }
`

const Signup = ({ setIsSignupVisible }) => {
    const [birth, setBirth] = useState('')
    const [address, setAddress] = useState('')
    const [pseudo, setPseudo] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleClickClose = () => {
        setIsSignupVisible(false)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError(null)
        setSuccess(false)
        setLoading(true)
        const lat = address.lat
        const lon = address.lon

        try {
            const response = await axios.post(
                `${apiUrl}/auth/signup`,
                {
                    email,
                    password,
                    birth,
                    pseudo,
                    lat,
                    lon,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            setSuccess(true)
            setEmail('')
            setPassword('')
            setBirth('')
            setPseudo('')
            setAddress('')

            if (response.status === 201) {
                setIsSignupVisible(false)
                window.location.reload()
            }
        } catch (err) {
            setError(
                err.response?.data?.message || 'Impossible de vous enregistrer.'
            )
        } finally {
            setLoading(false)
        }
    }

    return (
        <StyledSignupFormContainer>
            <StyledSignupFormBox>
                <p onClick={handleClickClose}>x</p>
                <h1>Signup</h1>
                <StyledSigninForm onSubmit={handleSubmit}>
                    <div>
                        <label>Pseudo</label>
                        <input
                            type="text"
                            value={pseudo}
                            onChange={(e) => setPseudo(e.target.value)}
                            placeholder="Pseudo"
                            required
                        />
                    </div>
                    <div>
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Adresse email"
                            required
                        />
                    </div>
                    <div>
                        <label>Mot de passe</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Mot de passe"
                            required
                        />
                    </div>
                    <div>
                        <label>Date de naissance</label>
                        <input
                            type="date"
                            value={birth}
                            onChange={(e) => setBirth(e.target.value)}
                            placeholder=""
                        />
                    </div>

                    <div>
                        <label>Localisation</label>
                        <AddressAutocomplete setAddress={setAddress} />
                    </div>

                    <div>
                        {!pseudo ||
                        !email ||
                        !password ||
                        !birth ||
                        !address ? (
                            <div>
                                Veuillez remplir toutes les cases pour vous
                                inscrire
                            </div>
                        ) : (
                            <StyledButton type="submit" disabled={loading}>
                                {loading ? 'Signing up...' : "S'inscrire"}
                            </StyledButton>
                        )}
                    </div>
                </StyledSigninForm>

                {success && (
                    <p style={{ color: 'green' }}>
                        Inscription réussie, vérifiez vos emails.
                    </p>
                )}
                {error && <p style={{ color: 'red' }}>{error}</p>}
            </StyledSignupFormBox>
        </StyledSignupFormContainer>
    )
}

export default Signup
